import { render, staticRenderFns } from "./UserScoreRule.vue?vue&type=template&id=73982d90&scoped=true&"
import script from "./UserScoreRule.vue?vue&type=script&lang=js&"
export * from "./UserScoreRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73982d90",
  null
  
)

export default component.exports